import React from "react";

const Spinner = ({ height = "50", width = "50" }) => (
  <svg
    className="animate-spin spinner"
    width={width}
    height={height}
    role="loader"
    viewBox="0 0 57 57"
    fill="none"
    data-testid="spinner"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="28" cy="6" r="6" fill="white" />
    <circle opacity="0.66" cx="6" cy="28" r="6" fill="white" />
    <circle opacity="0.44" cx="28" cy="51" r="6" fill="white" />
    <circle opacity="0.22" cx="51" cy="28" r="6" fill="white" />
    <circle
      opacity="0.11"
      cx="44.0563"
      cy="12.2365"
      r="6"
      transform="rotate(45 44.0563 12.2365)"
      fill="white"
    />
    <circle
      opacity="0.77"
      cx="12.9437"
      cy="12.2365"
      r="6"
      transform="rotate(45 12.9437 12.2365)"
      fill="white"
    />
    <circle
      opacity="0.55"
      cx="12.2365"
      cy="44.0564"
      r="6"
      transform="rotate(45 12.2365 44.0564)"
      fill="white"
    />
    <circle
      opacity="0.33"
      cx="44.7635"
      cy="44.0564"
      r="6"
      transform="rotate(45 44.7635 44.0564)"
      fill="white"
    />
  </svg>
);

export default Spinner;
